package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Mongolia Flag (20x15dp)
 *
 * - ISO Alpha-2: MN
 * - ISO Alpha-3: MNG
 * - ISO Numeric: 496
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Mongolia: ImageVector by lazy {
    ImageVector.Builder(
        name = "Mongolia:MN:MNG:496:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF4C67E8)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6f, 0f)
                horizontalLineTo(14f)
                verticalLineTo(15f)
                horizontalLineTo(6f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13f, 0f)
                horizontalLineTo(20f)
                verticalLineTo(15f)
                horizontalLineTo(13f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(8f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF8D000)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.759f, 4.303f)
                curveTo(3.125f, 4.303f, 3.208f, 3.686f, 3.208f, 3.686f)
                lineTo(3.509f, 3.037f)
                verticalLineTo(3.298f)
                verticalLineTo(3.686f)
                curveTo(3.509f, 3.769f, 3.623f, 3.602f, 3.623f, 3.401f)
                curveTo(3.623f, 3.201f, 3.759f, 2.9f, 3.759f, 2.9f)
                curveTo(3.759f, 2.9f, 3.764f, 2.799f, 3.768f, 2.7f)
                curveTo(3.79f, 2.751f, 3.833f, 2.795f, 3.9f, 2.862f)
                curveTo(3.911f, 2.874f, 3.923f, 2.887f, 3.936f, 2.9f)
                curveTo(4.015f, 2.98f, 4.004f, 3.192f, 3.995f, 3.376f)
                curveTo(3.987f, 3.543f, 3.98f, 3.686f, 4.041f, 3.686f)
                curveTo(4.169f, 3.686f, 4.16f, 3.111f, 4.16f, 3.111f)
                lineTo(4.375f, 3.686f)
                curveTo(4.375f, 3.686f, 4.392f, 4.303f, 3.759f, 4.303f)
                close()
                moveTo(3.759f, 2.54f)
                curveTo(3.775f, 2.446f, 3.773f, 2.572f, 3.768f, 2.7f)
                curveTo(3.75f, 2.657f, 3.747f, 2.61f, 3.759f, 2.54f)
                close()
                moveTo(4.712f, 5.427f)
                curveTo(4.712f, 5.929f, 4.292f, 6.336f, 3.774f, 6.336f)
                curveTo(3.256f, 6.336f, 2.837f, 5.929f, 2.837f, 5.427f)
                curveTo(2.837f, 4.926f, 3.256f, 4.519f, 3.774f, 4.519f)
                curveTo(4.292f, 4.519f, 4.712f, 4.926f, 4.712f, 5.427f)
                close()
                moveTo(2.356f, 7.128f)
                horizontalLineTo(1.25f)
                verticalLineTo(12.485f)
                horizontalLineTo(2.356f)
                verticalLineTo(7.128f)
                close()
                moveTo(6.25f, 7.128f)
                horizontalLineTo(5.144f)
                verticalLineTo(12.485f)
                horizontalLineTo(6.25f)
                verticalLineTo(7.128f)
                close()
                moveTo(2.644f, 7.174f)
                lineTo(3.722f, 7.842f)
                lineTo(4.937f, 7.174f)
                horizontalLineTo(2.644f)
                close()
                moveTo(3.722f, 12.5f)
                lineTo(2.644f, 11.833f)
                horizontalLineTo(4.937f)
                lineTo(3.722f, 12.5f)
                close()
                moveTo(2.644f, 8.059f)
                horizontalLineTo(4.904f)
                verticalLineTo(8.479f)
                horizontalLineTo(2.644f)
                verticalLineTo(8.059f)
                close()
                moveTo(4.904f, 11.18f)
                horizontalLineTo(2.644f)
                verticalLineTo(11.6f)
                horizontalLineTo(4.904f)
                verticalLineTo(11.18f)
                close()
                moveTo(3.798f, 10.948f)
                curveTo(4.435f, 10.948f, 4.952f, 10.447f, 4.952f, 9.83f)
                curveTo(4.952f, 9.212f, 4.435f, 8.712f, 3.798f, 8.712f)
                curveTo(3.161f, 8.712f, 2.644f, 9.212f, 2.644f, 9.83f)
                curveTo(2.644f, 10.447f, 3.161f, 10.948f, 3.798f, 10.948f)
                close()
                moveTo(2.502f, 5.76f)
                curveTo(2.502f, 5.76f, 2.541f, 6.927f, 3.691f, 6.927f)
                curveTo(4.841f, 6.927f, 5.027f, 5.76f, 5.027f, 5.76f)
                curveTo(5.027f, 5.76f, 4.582f, 6.475f, 3.765f, 6.475f)
                curveTo(2.947f, 6.475f, 2.502f, 5.76f, 2.502f, 5.76f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun MongoliaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Mongolia,
            contentDescription = "Mongolia Flag"
        )
    }
}
